import React from 'react';
import { KeyRound } from 'lucide-react';

// Domaines à effet du projet (rôle + focus, voir la page Organisation) : qui les tient et si l'on a la main.

export const domainState = (domains, key, user) => {
  const entry = domains?.[key];
  const holders = entry?.holders || [];
  const me = Number(user?.employee_id ?? user?.id);
  const mine = holders.some((h) => Number(h.employee_id) === me);
  return {
    key,
    holders,
    can: entry ? entry.can !== false : true,
    mine,
    locked: Boolean(entry) && entry.can === false,
    label: entry?.label || key,
    who: holders.map((h) => `${h.name} (${h.role})`).join(', '),
  };
};

const PRONOUN = { roadmap: 'la', budget: 'les', facturabilite: 'la' };

const names = (holders) => {
  const list = holders.map((h) => h.name);
  return list.length > 1 ? `${list.slice(0, -1).join(', ')} ou ${list[list.length - 1]}` : list[0];
};

/** Une ligne discrète : qui tient ce domaine sur le projet, et si l'on peut agir. */
export const DomainNote = ({ state, className = '' }) => {
  if (!state.holders.length) return null;
  const roles = [...new Set(state.holders.map((h) => h.role))].join(' / ');
  const text = state.locked
    ? `${state.label} : seul${state.holders.length > 1 ? 's' : ''} ${names(state.holders)} (${roles}) ${state.holders.length > 1 ? 'peuvent' : 'peut'} ${PRONOUN[state.key] || 'la'} modifier. Tu peux consulter ; pour changer, demande-${state.holders.length > 1 ? 'leur' : 'lui'}.`
    : `${state.label} : c'est ton domaine sur ce projet. Chaque changement demande un motif, gardé dans l'historique.`;
  return (
    <p className={`flex items-start gap-1.5 text-[11px] ${state.locked ? 'text-violet-700' : 'text-slate-500'} ${className}`}>
      <KeyRound size={12} className="mt-px shrink-0" />
      <span>{text}</span>
    </p>
  );
};
